module.exports = __webpack_public_path__ + "img/1723596732141-fb77e3f4-b136-4ca8-9ab4-5ff5d8946557.jpeg.a15d802a.webp";